export const HealthActions = {
    GetPing: 'GetPing',
};